import { Component, OnDestroy, OnInit, Input } from "@angular/core";
import { Subscription, forkJoin } from "rxjs";
import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";
import { Title } from "@angular/platform-browser";
import * as moment from 'moment';
declare var bootstrap: any;

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, OnDestroy {
    showFullContent = false;

    toggleShowContent() {
        this.showFullContent = !this.showFullContent;
    }

    days: string[] = [];
    weeks: { date: string, isCurrentMonth: boolean }[][] = [];
    currentMonth: moment.Moment;
    months: string[] = moment.months();
    // All clubs Data

    // Event

    // Event
    subscription: Subscription;
    slides = [];
    Notices = [];
    Notices2 = [];
    all_static_data: any;
    ContentData: any;
    loadingData = true;
    HomeContent: any;
    News_event_data: any;
    club_data: any;
    mission_data: any;
    vission_data: any;
    MainData: any;
    numVisibleCards: number;
    items: string[] = ["photos", "videos"];
    selectedItem: string = "photos";
    VideoAlbums: any;
    test: any;
    isSmall: boolean;
    isBig = true;
    isLeft = true;
    isMiddle = false;
    VideoAlbumShown = [];
    imageLoaded = false;
    ImageAlbums: any;
    ImageAlbumShown = [];
    GBMessages: any;
    GBMessageShown = [];
    foundnews: any;
    foundAchivements: any;
    foundCuricular: any;
    foundClubs: any;
    randomBackgroundColor: string = "#000000";
    hoverShadowColor: string = "#00000033";
    all_achievement_data: any;
    principalMessageData: any;
    chairmanMessageData: any;
    homeNotices: any[];
    co_curicular_data: any;
    statistics_data: any;
    // Visitor Stats
    visitorStats = {
        today: 0,
        thisWeek: 0,
        thisMonth: 0,
        thisYear: 0,
        total: 0
    };

    // Modal Image
    selectedImageModalUrl: string | null = null;
    selectedImageModalName: string | null = null;

    //all_news_event_data: any;

    constructor(
        private emitterService: EmitterService,
        private appService: AppService,
        private titleService: Title
    ) {
        // this.Notices2 = JSON.parse(localStorage.getItem('noticeData'));
        this.subscription = this.emitterService.currentMessage.subscribe(
            (message) => {
                if (message === true) {
                    let mainData = localStorage.getItem("mainData");

                    if (mainData != null) {
                        this.MainData = JSON.parse(mainData);
                    }
                    this.test = this.MainData;
                    console.log(this.MainData, "MainData");
                }
            }
        );
    }

    ngOnInit(): void {
        this.titleService.setTitle("Karatoa Multimedia School & College");
        this.numVisibleCards = window.innerWidth < 768 ? 1 : 3;

        // Log visitor
        this.appService.postVisitorLog().subscribe({
            next: (res) => console.log('Visitor logged', res),
            error: (err) => console.log('Error logging visitor', err)
        });

        this.FetchData();
        this.currentMonth = moment();
        this.generateCalendar();
        // AOS.init();
    }


    generateCalendar(): void {
        const startOfMonth = this.currentMonth.clone().startOf('month');
        const endOfMonth = this.currentMonth.clone().endOf('month');
        const startOfWeek = startOfMonth.clone().startOf('week');
        const endOfWeek = endOfMonth.clone().endOf('week');

        let day = startOfWeek.clone();
        this.weeks = [];

        while (day.isBefore(endOfWeek, 'day')) {
            const week: { date: string, isCurrentMonth: boolean }[] = [];
            for (let i = 0; i < 7; i++) {
                week.push({
                    date: day.format('D'),
                    isCurrentMonth: day.isSame(this.currentMonth, 'month')
                });
                day.add(1, 'day');
            }
            this.weeks.push(week);
        }
    }


    changeMonth(direction: 'prev' | 'next'): void {
        if (direction === 'prev') {
            this.currentMonth = this.currentMonth.subtract(1, 'month');
        } else {
            this.currentMonth = this.currentMonth.add(1, 'month');
        }
        this.generateCalendar();
    }

    openImageModal(imageUrl: string, imageName: string): void {
        this.selectedImageModalUrl = imageUrl;
        this.selectedImageModalName = imageName;
        if (typeof bootstrap !== 'undefined') {
            const modalEl = document.getElementById('imagePreviewModal');
            if (modalEl) {
                const modal = new bootstrap.Modal(modalEl);
                modal.show();
            }
        }
    }

    getEventClass(day: { date: string, isCurrentMonth: boolean }): string {
        if (!day.isCurrentMonth) return 'd-flex align-items-center justify-content-center';
        if (day.date === '6') return 'bg-success text-white rounded-circle d-flex align-items-center justify-content-center';
        if (day.date === '15') return 'bg-danger text-white rounded-circle d-flex align-items-center justify-content-center';
        if (day.date === '26') return 'bg-warning text-white rounded-circle d-flex align-items-center justify-content-center';
        return 'd-flex align-items-center justify-content-center';
    }

    getNoticeDateBg(index: number): string {
        const colors = ['bg-success', 'notice-bg-light', 'bg-danger', 'notice-bg-light'];
        return colors[index % colors.length];
    }

    getNoticeDateText(index: number): string {
        const textColors = ['text-white', 'text-dark', 'text-white', 'text-dark'];
        return textColors[index % textColors.length];
    }

    getStatConfig(categoryName: string): any {
        switch(categoryName) {
            case 'Student Count': return { icon: 'fa-users', color: '#ffc107', title: 'শিক্ষার্থী' };
            case 'Teacher Count': return { icon: 'fa-user-graduate', color: '#fff', title: 'শিক্ষক' };
            case 'Estimated': return { icon: 'fa-award', color: '#ffc107', title: 'বছরের শিক্ষার অভিজ্ঞতা' };
            case 'Success Rate': return { icon: 'fa-bullseye', color: '#0dcaf0', title: 'সাফল্যের হার' };
            default: return { icon: 'fa-chart-bar', color: '#fff', title: categoryName };
        }
    }

    getCampusLifeImage(menuUrl: string): string {
        const defaultImage = '../../../../assets/img/gallery-ph.jpg';
        if (!this.MainData || !this.MainData.SiteMapList || !this.ContentData) return defaultImage;
        
        // Find the menu by URL
        const menu = this.MainData.SiteMapList.find(m => m.MenuUrl && (m.MenuUrl.trim() === menuUrl || m.MenuUrl.trim() === "/" + menuUrl));
        if (!menu) return defaultImage;
        
        // Find the content by MenuCode
        const content = this.ContentData.find(c => c.MenuCode === menu.MenuCode);
        if (content && content.ShowAttachments && content.ShowAttachments.length > 0) {
            return content.ShowAttachments[0].FilePath;
        }
        
        return defaultImage;
    }

    getBengaliMonthYear(): string {
        if (!this.currentMonth) return '';
        const bnMonths = ['জানুয়ারি', 'ফেব্রুয়ারি', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্টেম্বর', 'অক্টোবর', 'নভেম্বর', 'ডিসেম্বর'];
        const enDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const bnDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

        const monthName = bnMonths[this.currentMonth.month()];
        let yearStr = this.currentMonth.year().toString();
        for (let i = 0; i < 10; i++) {
            yearStr = yearStr.split(enDigits[i]).join(bnDigits[i]);
        }
        return `${monthName} ${yearStr}`;
    }

    ngAfterViewChecked() {
        // AOS.refresh();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    FetchData() {
        forkJoin([
            this.appService.getNotices(),
            this.appService.getContents(),
            this.appService.getVideoAlbums(),
            this.appService.getImageAlbums(),
            this.appService.getGBMessages(),
            this.appService.getSlides(),
            this.appService.getVisitorSummary()
        ]).subscribe((response: any) => {
            console.log(response, "response FetchData");


            this.Notices = response[0].data.filter((x) => x.ShowScroll === true);
            this.Notices.sort((a, b) => b.Id - a.Id);
            this.homeNotices = this.Notices.slice(0, 6);

            this.ContentData = response[1].data;

            // To get Slider Data
            this.slides = response[5].data;
            if (this.slides && this.slides.length > 0) {
                this.slides.sort((a: any, b: any) => b.Id - a.Id);

                // Initialize Bootstrap Carousel manually since DOM is updated dynamically
                setTimeout(() => {
                    if (typeof bootstrap !== 'undefined') {
                        const carouselEl = document.getElementById('heroCarousel');
                        if (carouselEl) {
                            new bootstrap.Carousel(carouselEl, {
                                interval: 6000,
                                ride: 'carousel'
                            });
                        }
                    }
                }, 100);
            }
            if (this.ContentData != null) {
                let homeContent = this.ContentData.filter(
                    (x) => x.MenuCode == 187
                );
                this.HomeContent = homeContent;
                console.log(this.HomeContent, "Home Contebt");
            }

            // To get news event Data
            if (this.ContentData != null) {
                let news = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "News And Events"
                );
                news.sort((a: any, b: any) => b.Id - a.Id);
                this.News_event_data = news;
                this.foundnews = this.News_event_data.slice(0, 3);
                console.log(this.foundnews, "All News Event Data");
            }
            // To get Achievement Data
            if (this.ContentData != null) {
                let achievements_data = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Achievements"
                );
                achievements_data.sort((a: any, b: any) => b.Id - a.Id);
                this.all_achievement_data = achievements_data;
                this.foundAchivements = this.all_achievement_data.slice(0, 3);
                console.log(this.foundAchivements, "All Achievemet Data");
            }
            // To get curicular Data
            if (this.ContentData != null) {
                let curicular = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Co-Curicular"
                );
                curicular.sort((a: any, b: any) => b.Id - a.Id);
                this.co_curicular_data = curicular;
                this.foundCuricular = this.co_curicular_data.slice(0, 3);
                console.log(this.foundCuricular, "All Co-curicular Event Data");
            }

            // Native fetch to completely bypass any Angular or Browser caching
            const statsUrl = 'https://portal2websiteapi.cloudcampus24.com/api/v1/ContentClient/contents?_t=' + new Date().getTime();
            fetch(statsUrl, {
                method: 'GET',
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                    'X-App-Key': 'qbv27zCIel/deBnOb5BUYw==',
                    'X-App-Client': 'XSHeHMdGf1E='
                }
            })
            .then(res => res.json())
            .then(resData => {
                if (resData && resData.data) {
                    let stats = resData.data.filter((x: any) => x.CatParentName == "Total Member");
                    stats.sort((a: any, b: any) => a.Id - b.Id);
                    this.statistics_data = stats;
                }
            })
            .catch(err => {
                // Fallback to Angular Http response if fetch fails
                if (this.ContentData != null) {
                    let stats = this.ContentData.filter((x) => x.CatParentName == "Total Member");
                    stats.sort((a: any, b: any) => a.Id - b.Id);
                    this.statistics_data = stats;
                }
            });

            // To get GB Information
            this.GBMessages = response[4].data;
            console.log(this.GBMessages, "GB Messages");
            let filteredGBM = this.GBMessages.filter((item) =>
                item.Placement.includes("1")
            );
            this.GBMessageShown = filteredGBM;
            this.principalMessageData = this.GBMessages.find(x => x.GBDesignationName === "Principal");
            this.chairmanMessageData = this.GBMessages.find(x => x.GBDesignationName === "Chairman");
            console.log(this.GBMessageShown, "GBMessageShown");

            // To get Club Data
            if (this.ContentData != null) {
                let club_items = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Club"
                );
                this.club_data = club_items;
                this.foundClubs = this.club_data;
                console.log(this.foundClubs, "All club Data");
            }

            // To get Video Album Data
            this.VideoAlbums = response[2].data;
            if (this.VideoAlbums != null && this.VideoAlbums.length > 0) {
                this.VideoAlbums.sort((a: any, b: any) => b.Id - a.Id);
                const latestAlbumId = this.VideoAlbums[0].Id;
                this.appService.getVideoAlbumsById(latestAlbumId).subscribe((res: any) => {
                    if (res && res.data) {
                        let videos = res.data.filter((item: any) => item.IsAlbumFolder === false);
                        videos.sort((a: any, b: any) => b.Id - a.Id);
                        this.VideoAlbumShown = videos.slice(0, 4);
                    }
                });
            }

            // To get Image Album Data
            this.ImageAlbums = response[3].data;
            if (this.ImageAlbums != null) {
                this.ImageAlbums.sort((a: any, b: any) => b.Id - a.Id);
                this.ImageAlbumShown = this.ImageAlbums.slice(0, 9);
            }

            // Process Visitor Stats
            let summaryRes = response[6];
            if (summaryRes && summaryRes.data) {
                this.visitorStats = {
                    today: summaryRes.data.TodayTotalVisitor || 0,
                    thisWeek: summaryRes.data.WeeklyTotalVisitor || 0,
                    thisMonth: summaryRes.data.MonthlyTotalVisitor || 0,
                    thisYear: summaryRes.data.YearlyTotalVisitor || 0,
                    total: summaryRes.data.GrandTotalVisitor || 0
                };
            }

            this.loadingData = false;

            setTimeout(() => {
                const carouselElement = document.getElementById('carouselExampleCaptions');
                if (carouselElement) {
                    const carousel = new bootstrap.Carousel(carouselElement, {
                        interval: 10000,
                        ride: 'carousel'
                    });
                    carousel.cycle();
                }
            }, 300);
        });
    }

    TransformUrl(value) {
        if (value.includes("https://")) {
            return value;
        } else {
            return `https://${value}`;
        }
    }

    getYouTubeThumbnail(url: string): string {
        if (!url) return '/assets/img/school/logo.png';
        const videoRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?)(.*)(?:v=)([a-zA-Z0-9_-]{11})(&|$)/;
        const match = url.match(videoRegex);
        if (match && match[2]) {
            return `https://img.youtube.com/vi/${match[2]}/hqdefault.jpg`;
        }
        const shortRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/)([a-zA-Z0-9_-]{11})(&|$)/;
        const shortMatch = url.match(shortRegex);
        if (shortMatch && shortMatch[1]) {
            return `https://img.youtube.com/vi/${shortMatch[1]}/hqdefault.jpg`;
        }
        return '/assets/img/school/logo.png';
    }

    stripHtml(html: string) {
        if (!html) return '';
        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    onNavigate(url: string) {
        let MyUrl = "";
        if (url.startsWith("http://") || url.startsWith("https://")) {
            MyUrl = url;
        } else {
            MyUrl = "https://" + url;
        }
        window.open(MyUrl, "_blank");
    }

    selectItem(item: string) {
        this.selectedItem = item;
    }

    onImageLoad() {
        this.imageLoaded = true;
    }
    // Test truncate starts
    truncateText(text, maxLength) {
        // Check if the text length is greater than the maximum length
        if (text.length > maxLength) {
            // Truncate the text to the maximum length and append "..." at the end
            return text.substring(0, maxLength) + "...";
        } else {
            // If the text length is within the maximum length, return the original text
            return text;
        }
    }

    getMessageHref(GBDesignationName: string): string {
        if (GBDesignationName === "Chief Patron") {
            return "/administration/message-of-chief-patron";
        } else if (GBDesignationName === "Chairman") {
            return "/administration/message-of-chairman";
        } else if (GBDesignationName === "Principal") {
            return "/administration/message-of-principal";
        } else {
            // Default href if none of the conditions match
            return "#";
        }
    }
    onCardHover() {
        this.hoverShadowColor = this.randomBackgroundColor;
    }

    onCardLeave() {
        this.hoverShadowColor = "#00000033";
    }

    // Start for modal view

    modalImageUrl: string;

    openModal(imageUrl: string): void {
        this.modalImageUrl = imageUrl; // Set the modal image URL dynamically
        document.getElementById("modal01").style.display = "block";
    }

    closeModal(): void {
        document.getElementById("modal01").style.display = "none";
    }

    // Test truncate ends
    // For Honur Board
    selectedDiv: string = "chiefPatron"; // Set default div to show

    showDiv(divId: string) {
        this.selectedDiv = divId;
    }
    smallScreen() {
        this.isSmall = window.innerWidth < 1200;
        this.isBig = window.innerWidth > 1200;
        this.isLeft = window.innerWidth > 1200;
        this.isMiddle = window.innerWidth < 1000;
    }

}

